import React, { useState, memo } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ChevronLeftIcon, ChevronRightIcon, EyeIcon, DownloadIcon, ArrowUpDownIcon, SearchIcon } from 'lucide-react';
export function PostaInviataTab() {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  // Dati di esempio per la demo
  const emailInviate = [{
    id: 1,
    tipo: 'amichevole',
    oggetto: '[CF-2023-0042] Promemoria pagamento fattura #12345',
    destinatario: 'mario.rossi@example.com',
    dataInvio: '2023-06-15T14:30:00',
    pratica: 'CF-2023-0042',
    cliente: 'Rossi SRL',
    stato: 'consegnata'
  }, {
    id: 2,
    tipo: 'formale',
    oggetto: '[CF-2023-0036] Sollecito pagamento fattura #10982',
    destinatario: 'amministrazione@verdi.it',
    dataInvio: '2023-06-14T10:15:00',
    pratica: 'CF-2023-0036',
    cliente: 'Verdi SpA',
    stato: 'consegnata'
  }, {
    id: 3,
    tipo: 'duro',
    oggetto: '[CF-2023-0029] Ultimo avviso pagamento fattura #9876',
    destinatario: 'info@bianchi.com',
    dataInvio: '2023-06-12T09:45:00',
    pratica: 'CF-2023-0029',
    cliente: 'Bianchi & Co.',
    stato: 'consegnata'
  }, {
    id: 4,
    tipo: 'pec',
    oggetto: '[CF-2023-0018] Diffida ad adempiere - Fattura #8765',
    destinatario: 'azienda@pec.neri.it',
    dataInvio: '2023-06-10T11:20:00',
    pratica: 'CF-2023-0018',
    cliente: 'Neri Costruzioni',
    stato: 'consegnata'
  }, {
    id: 5,
    tipo: 'amichevole',
    oggetto: '[CF-2023-0039] Promemoria pagamento fattura #11234',
    destinatario: 'contabilita@gialli.org',
    dataInvio: '2023-06-08T16:10:00',
    pratica: 'CF-2023-0039',
    cliente: 'Gialli Associati',
    stato: 'consegnata'
  }];
  // Funzione per ottenere il colore in base al tipo di comunicazione
  const getTipoColor = tipo => {
    switch (tipo) {
      case 'amichevole':
        return 'bg-[#1A3E5C]/10 text-[#1A3E5C]';
      case 'formale':
        return 'bg-[#D4A017]/10 text-[#D4A017]';
      case 'duro':
        return 'bg-[#D4A017]/20 text-[#D4A017]';
      case 'pec':
        return 'bg-[#B03030]/10 text-[#B03030]';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Funzione per ottenere l'etichetta del tipo di comunicazione
  const getTipoLabel = tipo => {
    switch (tipo) {
      case 'amichevole':
        return 'Sollecito Amichevole';
      case 'formale':
        return 'Sollecito Formale';
      case 'duro':
        return 'Sollecito Duro';
      case 'pec':
        return 'PEC Ufficiale';
      default:
        return tipo;
    }
  };
  // Funzione per formattare la data
  const formatDate = dateString => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };
  // Filtro per la ricerca
  const filteredEmails = emailInviate.filter(email => email.oggetto.toLowerCase().includes(searchQuery.toLowerCase()) || email.destinatario.toLowerCase().includes(searchQuery.toLowerCase()) || email.pratica.toLowerCase().includes(searchQuery.toLowerCase()) || email.cliente.toLowerCase().includes(searchQuery.toLowerCase()));
  return <Card data-id="element-407">
      <div className="sm:flex sm:items-center" data-id="element-408">
        <div className="sm:flex-auto" data-id="element-409">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-410">
            Storico comunicazioni inviate
          </h3>
          <p className="mt-2 text-sm text-gray-500" data-id="element-411">
            Elenco di tutte le comunicazioni inviate ai clienti, ordinate dalla
            più recente.
          </p>
        </div>
      </div>
      <div className="mt-4 flex justify-between items-center" data-id="element-412">
        <div className="w-full max-w-lg" data-id="element-413">
          <div className="relative mt-1 rounded-md shadow-sm" data-id="element-414">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-415">
              <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" data-id="element-416" />
            </div>
            <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-[#1A3E5C] focus:ring-[#1A3E5C] sm:text-sm" placeholder="Cerca per oggetto, destinatario, pratica o cliente..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-417" />
          </div>
        </div>
        <div className="ml-2" data-id="element-418">
          <Button variant="secondary" icon={<ArrowUpDownIcon className="h-4 w-4 mr-2" data-id="element-420" />} data-id="element-419">
            Ordina
          </Button>
        </div>
      </div>
      <div className="mt-6 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg" data-id="element-421">
        <table className="min-w-full divide-y divide-gray-300" data-id="element-422">
          <thead className="bg-gray-50" data-id="element-423">
            <tr data-id="element-424">
              <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sm:pl-6" data-id="element-425">
                Tipo
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-426">
                Oggetto
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-427">
                Destinatario
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-428">
                Data invio
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-429">
                Cliente
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-430">
                Stato
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6" data-id="element-431">
                <span className="sr-only" data-id="element-432">Azioni</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white" data-id="element-433">
            {filteredEmails.length === 0 ? <tr data-id="element-434">
                <td colSpan={7} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-435">
                  Nessuna comunicazione trovata
                </td>
              </tr> : filteredEmails.map(email => <tr key={email.id} className="hover:bg-gray-50" data-id="element-436">
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6" data-id="element-437">
                    <span className={`inline-flex rounded-full px-2 text-xs font-semibold ${getTipoColor(email.tipo)}`} data-id="element-438">
                      {getTipoLabel(email.tipo)}
                    </span>
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900" data-id="element-439">
                    <div className="font-medium" data-id="element-440">{email.oggetto}</div>
                    <div className="text-gray-500" data-id="element-441">
                      Pratica: {email.pratica}
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-442">
                    {email.destinatario}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-443">
                    {formatDate(email.dataInvio)}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-444">
                    {email.cliente}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-445">
                    <span className="inline-flex rounded-full bg-[#4A8F6A]/20 px-2 text-xs font-semibold text-[#4A8F6A]" data-id="element-446">
                      {email.stato}
                    </span>
                  </td>
                  <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" data-id="element-447">
                    <div className="flex space-x-2 justify-end" data-id="element-448">
                      <button type="button" className="text-[#1A3E5C] hover:text-[#15324a]" data-id="element-449">
                        <EyeIcon className="h-5 w-5" data-id="element-450" />
                        <span className="sr-only" data-id="element-451">Visualizza</span>
                      </button>
                      <button type="button" className="text-[#1A3E5C] hover:text-[#15324a]" data-id="element-452">
                        <DownloadIcon className="h-5 w-5" data-id="element-453" />
                        <span className="sr-only" data-id="element-454">Scarica</span>
                      </button>
                    </div>
                  </td>
                </tr>)}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 mt-4" data-id="element-455">
        <div className="flex flex-1 justify-between sm:hidden" data-id="element-456">
          <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-457">
            Precedente
          </button>
          <button onClick={() => setCurrentPage(currentPage + 1)} className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-458">
            Successiva
          </button>
        </div>
        <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-459">
          <div data-id="element-460">
            <p className="text-sm text-gray-700" data-id="element-461">
              Visualizzati{' '}
              <span className="font-medium" data-id="element-462">{filteredEmails.length}</span> di{' '}
              <span className="font-medium" data-id="element-463">{emailInviate.length}</span>{' '}
              risultati
            </p>
          </div>
          <div data-id="element-464">
            <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-465">
              <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0" data-id="element-466">
                <span className="sr-only" data-id="element-467">Precedente</span>
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-468" />
              </button>
              <span aria-current="page" className="relative z-10 inline-flex items-center bg-[#1A3E5C] px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1A3E5C]" data-id="element-469">
                {currentPage}
              </span>
              <button onClick={() => setCurrentPage(currentPage + 1)} className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0" data-id="element-470">
                <span className="sr-only" data-id="element-471">Successiva</span>
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-472" />
              </button>
            </nav>
          </div>
        </div>
      </div>
    </Card>;
}